export const errMsgIsOffline = (message: string) => {
    var m = message.toUpperCase();
    return m.includes("NETWORK") || m.includes("FAILED TO FETCH") || m.includes("ERR");
}

export const isProductionEnvironment = process.env.REACT_APP_ENV === "production";

export const logDev = (message: string) => {
    if (!isProductionEnvironment) {
        console.log(message);
    }
}
